module.exports = __webpack_public_path__ + "img/1-fr.135ac3a4.jpg";